import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../../utils/inview'
import { PictureLayout } from '../../../image/imageLayout'
import { ImageBlock } from '../blocksState'

export const ImageBlockLayout = (props: ImageBlock) => (
  <InView
    as="section"
    threshold={0}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--wysiwyg block--image"
  >
    <div className="block__inner container--m gutter--m">
      <div className="block__content text--styled">
        {props.items
          .filter((item) => item.type == 'image')
          .map((item) => (
            <Image key={`image-${
              item.mobileImage?.url
              ?? item.tabletImage?.url
              ?? item.image?.url
            }`} item={item} />
          ))}
      </div>
    </div>
  </InView>
)

const isNotNull = <a,>(x: a | null | undefined): x is a => x != null

const getImageSourceProps = (
  image: ImageBlock['items'][number]['image'] | undefined,
  media: string
) =>
  image?.url
    ? {
        url: image.url,
        alt: image.alt,
        media: media,
      }
    : undefined

const Image = (props: { item: ImageBlock['items'][number] }) => {
  const { item } = props
  const sources = [
    getImageSourceProps(item.mobileImage, '(min-width: 20rem)'),
    getImageSourceProps(item.tabletImage, '(min-width: 48rem)'),
    getImageSourceProps(item.image, '(min-width: 60rem)'),
  ].filter(isNotNull)

  const [mobileSource, ...otherSources] = sources
  return (
    <figure className="image">      
      <PictureLayout.Wrapper>
        {otherSources.map((image) => (
          <PictureLayout.Source key={`source-${image.media}`} srcSet={image.url} media={image.media} />
        ))}
        {mobileSource && (
          <PictureLayout.Img
            image={{
              Url: mobileSource.url,
              Title: mobileSource.alt,
            }}
            width="720"
            height="720"
            lazyload
          />
        )}
      </PictureLayout.Wrapper>

      {item.caption && (
        <figcaption>
          <p>{item.caption}</p>
        </figcaption>
      )}
    </figure>
  )
}
